export const createOption = (label: string, value?: string) => ({
    label,
    value: value ?? label,
});

export interface Option {
    label: string;
    value: string;
}